import type ServiceApi from "../../api";
import {ErrorI18n} from "../../i18n";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import {credentialsIsBasicAuth} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {RevaApiAuthorizeResult} from "../payload-types/authorize";
import {FailedValidation, ValidationErrorI18n} from "../validation";
import {WebError} from "../web-error";

export class AuthorizeApiInterface extends SimpleApiInterface<RevaApiAuthorizeResult> {
    constructor(private credentials: ApiCredentials) {
        super();
    }

    async execute(api: ServiceApi): Promise<RevaApiAuthorizeResult> {
        return super.execute(api, this.credentials);
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_AUTHORIZE]);
    }

    protected validate(): void {
        if (!credentialsIsBasicAuth(this.credentials)) {
            return;
        }
        const {username, password} = this.credentials;
        if (!username && !password) {
            throw new ValidationErrorI18n(
                [new FailedValidation("username"), new FailedValidation("password")],
                "login.error.usernameAndPasswordEmpty",
            );
        }
        if (!username) {
            throw new ValidationErrorI18n(new FailedValidation("username"), "login.error.usernameEmpty");
        }
        if (!password) {
            throw new ValidationErrorI18n(new FailedValidation("password"), "login.error.passwordEmpty");
        }
    }

    protected handleApiErrors(e: Error): RevaApiAuthorizeResult {
        if (e instanceof WebError && e.status === 401 && e.getErrorCode() === "A200") {
            throw new ErrorI18n("login.error.401");
        }
        return super.handleApiErrors(e);
    }

    protected executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<RevaApiAuthorizeResult> {
        return executor.fetchGET(url, credentials);
    }
}
